import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { overlay } from 'overlay-kit';
import { logger } from '@zep/core-logger';
import { Button, Dialog, DialogFooter, DialogHeader, DialogOverlay, DialogPanel, DialogTitle } from '@zep/ui';
import { buildAuthAppSigninUrl } from '../../utils/auth';
export function useSsoErrorDialog() {
  const {
    locale
  } = useRouter();
  const {
    t
  } = useTranslation(['common']);
  const handleOpen = (error?: Error | unknown) => {
    if (error) {
      logger.captureError(error, {
        tags: {
          feature: 'sso',
          action: 'error_dialog'
        }
      });
      logger.track('sso_error_dialog_opened', {
        errorName: error instanceof Error ? error.name : 'Unknown',
        errorMessage: error instanceof Error ? error.message : 'Unknown'
      });
    }
    overlay.open(({
      unmount
    }) => <SsoErrorDialog title={t('common:error.api.unknown')} confirmLabel={t('common:confirm')} onClose={() => {
      unmount();
      // Auth App 로그인 페이지로 리다이렉트
      window.location.replace(buildAuthAppSigninUrl(locale ?? 'en'));
    }} />);
  };
  return {
    handleOpen
  };
}
function SsoErrorDialog({
  title,
  confirmLabel,
  onClose
}: {
  title: string;
  confirmLabel: string;
  onClose: () => void;
}) {
  return <Dialog open={true} onClose={onClose} maxWidth="400px" data-sentry-element="Dialog" data-sentry-component="SsoErrorDialog" data-sentry-source-file="useSsoErrorDialog.tsx">
      <DialogOverlay data-sentry-element="DialogOverlay" data-sentry-source-file="useSsoErrorDialog.tsx" />
      <DialogPanel data-sentry-element="DialogPanel" data-sentry-source-file="useSsoErrorDialog.tsx">
        <DialogHeader onClose={onClose} data-sentry-element="DialogHeader" data-sentry-source-file="useSsoErrorDialog.tsx">
          <DialogTitle data-sentry-element="DialogTitle" data-sentry-source-file="useSsoErrorDialog.tsx">{title}</DialogTitle>
        </DialogHeader>
        <DialogFooter data-sentry-element="DialogFooter" data-sentry-source-file="useSsoErrorDialog.tsx">
          <Button onClick={onClose} data-sentry-element="Button" data-sentry-source-file="useSsoErrorDialog.tsx">{confirmLabel}</Button>
        </DialogFooter>
      </DialogPanel>
    </Dialog>;
}